export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offerte"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I miei scambi"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["I miei annunci"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scambi"])}
}